// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-link{cursor:pointer;font-size:clamp(.8rem,1rem + 60vw,1rem);word-break:break-word!important}.v-treeview-node__level{width:25px!important}.v-treeview-node__content{margin-left:0!important}.v-treeview--dense .v-treeview-node__root{min-height:25px!important}.v-treeview-node__content>.v-treeview-node__label>.active-menu-item{color:var(--v-primary-base)!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
